﻿<template>
    <login_screen screen="register"></login_screen>
</template>

<script lang="ts" src="./register.ts"></script>